import React from 'react'
import DatePickerField from '../../formFields/datePickerField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <DatePickerField {...fieldProps} />
))
